import React, { useState, useCallback } from "react";
import * as S from "./styled";
import PT from "prop-types";
import TextSearch from "../TextSearch/Desktop";
import SettingsIcon from "_c/icon/Settings";
import Sticky from "react-stickynode";
import { useHasFilters } from "../Filters/hooks";
import uiVars from "_c/AppShell/ui-vars";

const DesktopTopBar = (props) => {
  const [isSticky, setIsSticky] = useState(false);
  const onStickyStateChange = useCallback(({ status }) => {
    setIsSticky(status === 2);
  }, []);
  const hasFilters = useHasFilters(props.query);
  return (
    <S.Wrap>
      <Sticky
        top={parseInt(uiVars.headDesktopHeight)}
        innerZ={10}
        onStateChange={onStickyStateChange}
      >
        <S.MainLine isSticky={isSticky}>
          <TextSearch
            updateQuery={props.updateQuery}
            query={props.query}
            t={props.t}
          />
          <S.Buttons>
            <S.FiltersButton light large onClick={props.openFilters}>
              <SettingsIcon
                color={hasFilters ? "var(--color-cta)" : "var(--color-primary)"}
                width="18"
              />
            </S.FiltersButton>
          </S.Buttons>
        </S.MainLine>
      </Sticky>
      <div style={{ height: "15px" }} />
    </S.Wrap>
  );
};
DesktopTopBar.propTypes = {
  query: PT.object.isRequired,

  openFilters: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default DesktopTopBar;
